const LABEL_POSITION = 'right'; // "left" | "right" | "prefer-right"
const LABEL_PADDING = 3;
const LABEL_FONT_SIZE = 14;
const BAR_PADDING = 8;
const HEIGHT = 40;
const yearMin = 1945;
const yearMax = new Date().getFullYear();

export function renderSearchTimelineCanvas() {
	const targetElement = document.querySelector('.searchTimelineCanvas');
	if (!targetElement) {
		return;
	}

	const canvas = document.createElement('canvas');
	Object.assign(canvas.style, {
		background: '#e8e3d8',
		boxShadow: 'inset 0 2px 7px rgba(0, 0, 0, 0.4)',
		width: '100%',
		height: `${HEIGHT}px`,
	});
	canvas.height = HEIGHT;
	const ctx = canvas.getContext('2d');

	targetElement.appendChild(canvas);

	function renderDecade(year, x, width) {
		const text = year > 2000 ? `'${year - 2000}` : `${year}`;
		ctx.font = `${LABEL_FONT_SIZE}px Georgia, serif`;
		const textWidth = ctx.measureText(text).width;
		let textX;
		if (LABEL_POSITION === 'left') {
			textX = x - (LABEL_PADDING + textWidth);
			if (textX < 0) {
				console.info('label does not fit', year);
				return;
			}
		} else {
			textX = x + LABEL_PADDING;
			if (textX + textWidth > width) {
				if (LABEL_POSITION === 'prefer-right') {
					textX = x - (LABEL_PADDING + textWidth);
					if (textX < 0) {
						console.info('label does not fit', year);
						return;
					}
				} else {
					console.info('label does not fit', year);
					return;
				}
			}
		}

		ctx.fillText(text, textX, LABEL_FONT_SIZE - 1);
	}

	function renderMarker(isDecade, x) {
		const markerHeight = isDecade ? HEIGHT : HEIGHT * 0.333;
		ctx.fillStyle = isDecade ? '#000000' : '#a29e98';
		ctx.fillRect(x, HEIGHT - markerHeight, 1, markerHeight);
	}

	function tick() {
		if (!ctx) throw new Error('no context');
		const width = canvas.getBoundingClientRect().width;
		if (!width) throw new Error('no width');

		canvas.width = width;
		const steps = yearMax - yearMin;

		const stepWidth = (width - 2 * BAR_PADDING) / steps;

		ctx.clearRect(0, 0, width, HEIGHT);

		for (let i = 0; i <= steps; i++) {
			const year = yearMin + i;
			const isDecade = year % 10 === 0;

			const x = BAR_PADDING + Math.round(stepWidth * i);
			renderMarker(isDecade, x);

			if (isDecade) {
				renderDecade(year, x, width);
			}
		}
	}

	tick();
	window.addEventListener('resize', () => tick());
}
